import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    aria-labelledby="confirmation-dialog-title"
    aria-describedby="confirmation-dialog-description"
    PaperProps={{
      sx: {
        bgcolor: '#1e1e1e',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '8px',
        color: 'white',
        minWidth: '300px',
      },
    }}
  >
    <DialogTitle id="confirmation-dialog-title">
      <Typography
        component="div"
        sx={{
          fontFamily: 'Rubik Mono One',
          color: '#cc0000',
        }}
      >
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent>
      <DialogContentText
        id="confirmation-dialog-description"
        sx={{ color: 'rgba(255, 255, 255, 0.8)' }}
      >
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ padding: '16px' }}>
      <Button
        onClick={onClose}
        autoFocus
        sx={{
          color: 'white',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          onConfirm();
        }}
        variant="contained"
        sx={{
          backgroundColor: '#8b0000',
          color: 'white',
          '&:hover': {
            backgroundColor: '#cc0000',
          },
        }}
      >
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);
